"use client";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/recuperacion_contraseña.css";

function RecuperacionContraseña() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  // Envío real de email de recuperación usando el backend
  async function enviarEmailRecuperacion({ toEmail }) {
    const response = await fetch(`${process.env.REACT_APP_API_BASE}/sistema/usuarios/recuperar-contrasena/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: toEmail })
    });
    const data = await response.json();
    if (!response.ok || data.success === false) {
      throw new Error(data.error || 'No se pudo enviar el correo. Intenta más tarde.');
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");
    if (!email || !email.includes("@")) {
      setErrorMsg("Ingresa un correo válido");
      window.alert("Ingresa un correo válido");
      return;
    }
    setLoading(true);
    try {
      await enviarEmailRecuperacion({ toEmail: email });
      setSuccessMsg("Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.");
      window.alert("Si el correo está registrado, recibirás un enlace para restablecer tu contraseña.");
    } catch (err) {
      const msg = err.message || "Ocurrió un error al enviar el correo. Intenta más tarde.";
      setErrorMsg(msg);
      window.alert(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="password-recovery-screen">
      <section className="recovery-container">

        {/* 🔙 Flecha para volver atrás */}
        <button className="back-button" onClick={() => navigate(-1)}>
          ←
        </button>

        <header className="logo-section">
          <img
            src="/lux_logo.png"
            alt="Lux Logo"
            className="logo"
            style={{ width: 60, marginBottom: 18 }}
          />
        </header>

        <h1 className="page-title" style={{ fontSize: '1.5em', fontWeight: 'bold', marginBottom: 10, color: '#222' }}>
          Restablece tu contraseña
        </h1>
        <div className="greeting" style={{ marginBottom: 18, color: '#444' }}>
          Ingresa tu correo institucional para recibir el enlace de recuperación.
        </div>

        <form className="recovery-form" onSubmit={handleSubmit} style={{ textAlign: 'center' }}>
          <label htmlFor="email" className="email-label" style={{ fontWeight: 'bold', color: '#444' }}>
            CORREO INSTITUCIONAL
          </label>

          <input
            type="email"
            id="email"
            className="email-input"
            placeholder="correo@universidad.edu"
            aria-describedby="email-help"
            value={email}
            onChange={e => setEmail(e.target.value)}
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '8px',
              border: '1px solid #ccc',
              margin: '12px 0 8px 0',
              fontSize: '1em',
              boxSizing: 'border-box'
            }}
          />

          <p id="email-help" className="help-text" style={{ color: '#888', marginBottom: 18 }}>
            Al ingresar tu correo electrónico recibirás un enlace para recuperar tu cuenta.
          </p>

          {errorMsg && <div className="error-message" style={{ color: '#d32f2f', marginBottom: 12 }}>{errorMsg}</div>}
          {successMsg && <div className="success-message" style={{ color: '#388e3c', marginBottom: 12 }}>{successMsg}</div>}

          <button
            type="submit"
            className="recovery-button"
            disabled={loading}
            style={{
              background: '#f9b233',
              color: '#fff',
              fontWeight: 'bold',
              padding: '14px 32px',
              borderRadius: '30px',
              fontSize: '1.1em',
              border: 'none',
              marginBottom: 24,
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'background 0.2s'
            }}
          >
            {loading ? "Enviando..." : "Establecer nueva contraseña"}
          </button>
        </form>

        <div className="footer" style={{ color: '#888', fontSize: '0.95em', marginTop: 18, textAlign: 'center' }}>
          Si no solicitaste restablecer tu contraseña, puedes ignorar este mensaje.<br />
          © 2025 Universidad Lux. Todos los derechos reservados.
        </div>
      </section>
    </main>
  );
}

export default RecuperacionContraseña;
